export const manifest = {
  screens: {
    scr_2mixmg: { name: "Home", route: "/" },
  },
}
